export default __webpack_public_path__ + "static/media/slide-c.b6b35917.jpg";